// extracted by mini-css-extract-plugin
export default {"wrapper":"_1B58p","secondaryButton":"_1tngr","primaryButton":"_3ocg5"};